/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EnumerationValueDto } from './EnumerationValueDto';
import {
    EnumerationValueDtoFromJSON,
    EnumerationValueDtoFromJSONTyped,
    EnumerationValueDtoToJSON,
} from './EnumerationValueDto';
import type { NumericValueDto } from './NumericValueDto';
import {
    NumericValueDtoFromJSON,
    NumericValueDtoFromJSONTyped,
    NumericValueDtoToJSON,
} from './NumericValueDto';
import type { NumericListDto } from './NumericListDto';
import {
    NumericListDtoFromJSON,
    NumericListDtoFromJSONTyped,
    NumericListDtoToJSON,
} from './NumericListDto';

/**
 * 
 * @export
 * @interface PhotonBeamQualityDto
 */
export interface PhotonBeamQualityDto {
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualityDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualityDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof PhotonBeamQualityDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualityDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PhotonBeamQualityDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PhotonBeamQualityDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PhotonBeamQualityDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualityDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualityDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualityDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {NumericListDto}
     * @memberof PhotonBeamQualityDto
     */
    availableDoseRates: NumericListDto;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof PhotonBeamQualityDto
     */
    radiationType: EnumerationValueDto;
    /**
     * 
     * @type {NumericValueDto}
     * @memberof PhotonBeamQualityDto
     */
    energy: NumericValueDto;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof PhotonBeamQualityDto
     */
    highDoseTechniqueType: EnumerationValueDto;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof PhotonBeamQualityDto
     */
    primaryFluenceShaping: EnumerationValueDto;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualityDto
     */
    $type?: PhotonBeamQualityDtoTypeEnum;
}


/**
 * @export
 */
export const PhotonBeamQualityDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoTreatmentMachinesConfigurationPhotonBeamQualityDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.PhotonBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type PhotonBeamQualityDtoTypeEnum = typeof PhotonBeamQualityDtoTypeEnum[keyof typeof PhotonBeamQualityDtoTypeEnum];



/**
 * Check if a given object implements the PhotonBeamQualityDto interface.
 */
export function instanceOfPhotonBeamQualityDto(value?: unknown): value is PhotonBeamQualityDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(PhotonBeamQualityDtoTypeEnum)[0];
}

export function PhotonBeamQualityDtoFromJSON(json: any): PhotonBeamQualityDto {
    return PhotonBeamQualityDtoFromJSONTyped(json, false);
}

export function PhotonBeamQualityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhotonBeamQualityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'deleterUserId': json['deleterUserId'] == null ? undefined : json['deleterUserId'],
        'deletionTime': json['deletionTime'] == null ? undefined : json['deletionTime'],
        'name': json['name'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'availableDoseRates': NumericListDtoFromJSON(json['availableDoseRates']),
        'radiationType': EnumerationValueDtoFromJSON(json['radiationType']),
        'energy': NumericValueDtoFromJSON(json['energy']),
        'highDoseTechniqueType': EnumerationValueDtoFromJSON(json['highDoseTechniqueType']),
        'primaryFluenceShaping': EnumerationValueDtoFromJSON(json['primaryFluenceShaping']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function PhotonBeamQualityDtoToJSON(value?: Omit<PhotonBeamQualityDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'isDeleted'|'deleterUserId'|'deletionTime'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'name': value['name'],
        'iuid': value['iuid'],
        'availableDoseRates': NumericListDtoToJSON(value['availableDoseRates']),
        'radiationType': EnumerationValueDtoToJSON(value['radiationType']),
        'energy': NumericValueDtoToJSON(value['energy']),
        'highDoseTechniqueType': EnumerationValueDtoToJSON(value['highDoseTechniqueType']),
        'primaryFluenceShaping': EnumerationValueDtoToJSON(value['primaryFluenceShaping']),
        '$type': value['$type'],
    });
}

